import { ResourceTypeEnum } from '@/shared/components/ui/resource-icon/resource-icon.types';

/**
 * Resource types that can be scoped to a group (`<prefix>:group:<groupId>`),
 * mirroring the resource types that live in groups — the inner group tabs.
 * Anything absent here only supports id/wildcard resources.
 */
export const GROUP_AGGREGATION_RESOURCE_TYPES: ResourceTypeEnum[] = [
  ResourceTypeEnum.Device,
  ResourceTypeEnum.Project,
  ResourceTypeEnum.Gateway,
  ResourceTypeEnum.Pipeline,
  ResourceTypeEnum.Identity,
  ResourceTypeEnum.Vault,
  ResourceTypeEnum.Document,
  ResourceTypeEnum.License,
  ResourceTypeEnum.Workstation,
  ResourceTypeEnum.Integration,
  ResourceTypeEnum.Group,
  ResourceTypeEnum.BackofficeUser,
  ResourceTypeEnum.BackofficeUserRole,
  ResourceTypeEnum.BackofficeGroup,
  ResourceTypeEnum.BackofficeTenant,
];

/**
 * Resource types that can be scoped to a tag (`<prefix>:tag:<name>`) — only
 * assets carry tags, so anything else (integrations, webhooks, users, groups)
 * has no tag aggregation.
 */
export const TAG_AGGREGATION_RESOURCE_TYPES: ResourceTypeEnum[] = [
  ResourceTypeEnum.Device,
  ResourceTypeEnum.Document,
  ResourceTypeEnum.Gateway,
  ResourceTypeEnum.License,
  ResourceTypeEnum.Pipeline,
  ResourceTypeEnum.Project,
  ResourceTypeEnum.Vault,
  ResourceTypeEnum.Workstation,
];

/**
 * Resource types with nothing to select: a policy for them always covers every
 * resource of that type, so the editor writes `<prefix>:*` itself and shows no
 * resource input.
 */
export const WILD_CARD_ONLY_RESOURCE_TYPES: ResourceTypeEnum[] = [
  ResourceTypeEnum.AuditLog,
  ResourceTypeEnum.CustomField,
  ResourceTypeEnum.Vulnerabilities,
  ResourceTypeEnum.Ideaas,
  // Orchestrator config is a small fixed set of global rows with no per-resource
  // selector — a policy grants the whole `backofficeEc2OrchestratorConfig:*`.
  ResourceTypeEnum.BackofficeEc2OrchestratorConfig,
];

/** Resource types whose policy prefix isn't just the lowercased enum value. */
export const POLICY_PREFIX_OVERRIDES: Partial<
  Record<ResourceTypeEnum, string>
> = {
  [ResourceTypeEnum.Group]: 'resourceGroup',
  [ResourceTypeEnum.AuditLog]: 'auditLog',
  [ResourceTypeEnum.CustomField]: 'customField',
};
